/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Dialog_Close_LabelInputs */

const en_components_dialog_close_label = /** @type {(inputs: Components_Dialog_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const de_components_dialog_close_label = /** @type {(inputs: Components_Dialog_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const pt_br2_components_dialog_close_label = /** @type {(inputs: Components_Dialog_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const tr_components_dialog_close_label = /** @type {(inputs: Components_Dialog_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapat`)
};

const zh_cn2_components_dialog_close_label = /** @type {(inputs: Components_Dialog_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const zh_hk2_components_dialog_close_label = /** @type {(inputs: Components_Dialog_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關閉`)
};

const ko_kr2_components_dialog_close_label = /** @type {(inputs: Components_Dialog_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`닫기`)
};

const ru_ru2_components_dialog_close_label = /** @type {(inputs: Components_Dialog_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть`)
};

const es_419_components_dialog_close_label = /** @type {(inputs: Components_Dialog_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Components_Dialog_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_dialog_close_label = /** @type {((inputs?: Components_Dialog_Close_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Dialog_Close_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_dialog_close_label(inputs)
	if (locale === "de") return de_components_dialog_close_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_dialog_close_label(inputs)
	if (locale === "tr") return tr_components_dialog_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_dialog_close_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_dialog_close_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_dialog_close_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_dialog_close_label(inputs)
	return es_419_components_dialog_close_label(inputs)
});